<template>
  <button
    :type="type"
    :disabled="disabled"
    :class="buttonClasses"
  >
    <span v-if="$slots.leading" class="ui-button__leading">
      <slot name="leading" />
    </span>
    <span v-if="$slots.default" class="ui-button__label">
      <slot />
    </span>
    <span v-if="$slots.trailing" class="ui-button__trailing">
      <slot name="trailing" />
    </span>
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue';

type ButtonType = 'button' | 'submit' | 'reset';
type ButtonVariant = 'solid' | 'ghost' | 'soft';
type ButtonTone = 'neutral' | 'primary' | 'danger';
type ButtonSize = 'sm' | 'md';

const props = withDefaults(defineProps<{
  type?: ButtonType;
  variant?: ButtonVariant;
  tone?: ButtonTone;
  size?: ButtonSize;
  iconOnly?: boolean;
  block?: boolean;
  disabled?: boolean;
}>(), {
  type: 'button',
  variant: 'solid',
  tone: 'neutral',
  size: 'md',
  iconOnly: false,
  block: false,
  disabled: false
});

const buttonClasses = computed(() => [
  'ui-button',
  `ui-button--${props.variant}`,
  `ui-button--${props.tone}`,
  `ui-button--${props.size}`,
  {
    'ui-button--icon-only': props.iconOnly,
    'ui-button--block': props.block
  }
]);
</script>